<ng-container *appUnauthed>
    <app-home-hero class="max-content-width"></app-home-hero>
    <app-home-search-cta-banner class="max-content-width"></app-home-search-cta-banner>
    @if (featuredContent$ | async; as featuredContent) {
        @if (selectedProduct$ | async; as selectedProduct) {
            @if (!featuredContent.products?.length || featuredContent.products.includes(selectedProduct)) {
                <div class="wrapper featured-wrapper">
                    <app-featured-content
                        [featuredContent]="featuredContent"
                        [thumbnailBelow]="true"></app-featured-content>
                </div>
            }
        }
    } @else {
        <div class="wrapper featured-wrapper">
            <app-featured-content [featuredContent]="null"></app-featured-content>
        </div>
    }
</ng-container>

<ng-container *appAuthed>
    <app-profile-banner [showCustomerAssistant]="true"></app-profile-banner>
    @if (featuredContent$ | async; as featuredContent) {
        @if (selectedProduct$ | async; as selectedProduct) {
            @if (!featuredContent.products?.length || featuredContent.products.includes(selectedProduct)) {
                <div class="wrapper">
                    <app-featured-content [featuredContent]="featuredContent"></app-featured-content>
                </div>
            }
        }
    } @else {
        <!--Defaults to loading skeleton feature content-->
        <div class="wrapper">
            <app-featured-content [featuredContent]="null"></app-featured-content>
        </div>
    }
    <div class="wrapper">
        <div class="columns">
            <div class="left">
                <app-home-favorites></app-home-favorites>
                <app-home-badges
                    [showSectionCtaLabel]="'View the Achiever\'s Lounge'"
                    [openNonModal]="true"></app-home-badges>
                <app-home-leaderboard></app-home-leaderboard>
                <app-home-recently-viewed></app-home-recently-viewed>
            </div>
            <div class="right">
                <app-home-jump-back-in></app-home-jump-back-in>
                <app-home-recommendations></app-home-recommendations>
            </div>
        </div>
        <app-home-fundamentals></app-home-fundamentals>
    </div>
</ng-container>
